import { ParticipantCopyId } from './participant-copy';

export type ParticipantCopyModal = Readonly<{
    nextParticipantCopySortIndex: number;
    currentlyEditedParticipantId: ParticipantCopyId;
}>;

export const initialParticipantCopyModalState: ParticipantCopyModal = {
    nextParticipantCopySortIndex: 1,
    currentlyEditedParticipantId: '',
};
